import { PlanInstitucional } from '../../models/plan-institucional';
import { PlanInstitucionalService } from '../../services/plan-institucional.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { PlanAniosService } from '../../services/plan-anios.service';
import { PlanesInstitucionalesAnualesService } from '../../services/planes-institucionales-anuales.service';
import { AniosObjetivosService } from '../../services/anios-objetivos.service';
import { AniosService } from '../../services/anios.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';

@Component({
  selector: 'app-plan-institucional',
  templateUrl: './plan-institucional.component.html',
  styleUrls: ['./plan-institucional.component.css'],
})
export class PlanInstitucionalComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Administración Procesos' },
    { label: 'Gestión Planes' },
    { label: 'Plan Institucional', active: true },
  ];

  public formPlanInstitucional!: UntypedFormGroup;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataApp: any[] = [];
  public dataPlanesAniosInactivos: any = [];
  public dataPlanesAniosEstado: any = [];
  public dataPlanesAniosEstadoInactivo: any = [];
  public dataPlanesAniosEstadoInactivoVector: any = [];
  public dataUnPlanInstitucionalActivo: any = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public aniosInactivos: any[];
  public vectorAnios: any[];
  public idSprPlanAnioUpdate: any;
  public estadoActivo: number = 1;
  public idSprPlanAnioEstadoUpdate: any;
  public nameModal: string = 'modalNewEdit';
  public sumaAniosMes: string;
  public sumaAniosMesInicio: string;
  nameApp = 'PLAN INSTITUCIONAL';
  aniosList: any[] = [];
  
  public dataPlan: any;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>()
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  readonly constant = ConstantsCatalogosIdService;
  
  constructor(
    private fb: FormBuilder,
    private planInstitucionalService: PlanInstitucionalService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private planAniosService: PlanAniosService,
    public aniosService: AniosService,
    private planesInstitucionalesAnualesService: PlanesInstitucionalesAnualesService,
    private aniosObjetivoService: AniosObjetivosService,
    private planesAniosService: AniosObjetivosService
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  get rolForm() {
    return this.formPlanInstitucional.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.formPlanInstitucional = this.fb.group({
      idSprPlanInstitucional: [],
      nombre: ['', [Validators.required]],
      //descripcion: [''],
      mision: ['', [Validators.required]],
      vision: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      estado: this.selectItems[0].value,
    });
  }

  initApp() {
    this.listDataApp();
    this.setDataTable();
    this.setForm();
    //this.controlFechasAniosInicio()
  }
  ngOnInit(): void {
    this.getIpPublic();
    this.initApp();
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  onSelectInitialDate() {
    let currentDate = new Date();
    const nuevaFecha = new Date(
      this.formPlanInstitucional.value.fechaInicio
        ? this.formPlanInstitucional.value.fechaInicio
        : currentDate
    ); // Crear una nueva instancia de Date basada en la fecha proporcionada
    nuevaFecha.setFullYear(nuevaFecha.getFullYear() + 4);

    this.formPlanInstitucional.patchValue({
      ...this.formPlanInstitucional.value,
      fechaFin: nuevaFecha.toISOString().slice(0, 10),
    });
  }

  //VALIDAR FECHA MÁXIMA A PARTIR DE UNA INICIAL
  // calculateMaxDate(){
  //   let currentDate = new Date()
  //   const nuevaFecha = new Date(this.formPlanInstitucional.value.fechaInicio?this.formPlanInstitucional.value.fechaInicio:currentDate); // Crear una nueva instancia de Date basada en la fecha proporcionada
  //   nuevaFecha.setFullYear(nuevaFecha.getFullYear() + 4);
  //   this.formPlanInstitucional.value.fechaFin = nuevaFecha.toISOString().slice(0, 10);
  //   return nuevaFecha.toISOString().slice(0, 10);
  // }

  listDataApp() {
    this.planInstitucionalService.list(`?delLog=N`).subscribe((resp) => {
      this.dataApp = resp;
      this.reDrawDataTable();
    });
  }

  verifyIfNotActivePlan(planes: any[]) {
    return planes.every((data) => data.estado !== 1);
  }

  getDataAnios() {
    this.planAniosService.list().subscribe((res) => {
      this.aniosList = res;
    });
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }
  controlFechasAnios() {
    //funcion que devuelve la fecha fin de una fecha inicio, entre 4 años.

    let fechaInicioFormulario = this.formPlanInstitucional.value.fechaInicio;
    let sumaAnios: any;
    //var primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
    let sumaFechas = new Date(fechaInicioFormulario);
    sumaFechas.setFullYear(sumaFechas.getFullYear() + 4);
    sumaAnios = sumaFechas.toISOString().slice(0, 10);
    var ultimoDia = new Date(
      sumaFechas.getFullYear(),
      sumaFechas.getMonth() + 1,
      0
    );
    this.sumaAniosMes = ultimoDia.toISOString().slice(0, 10);
    this.formPlanInstitucional.patchValue({
      ...this.formPlanInstitucional.value,
      fechaFin: this.sumaAniosMes,
    });
  }

  controlFechasAniosInicio(fechaInicio: any) {
    //funcion que devuelve la fecha fin de una fecha inicio, entre 4 años.

    let fechaInicioFormulario = fechaInicio;
    let sumaAnios: any;
    //var primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
    let sumaFechas = new Date(fechaInicioFormulario);
    sumaFechas.setFullYear(sumaFechas.getFullYear() + 4);
    sumaAnios = sumaFechas.toISOString().slice(0, 10);
    var ultimoDia = new Date(
      sumaFechas.getFullYear() - 1,
      sumaFechas.getMonth() + 1,
      0
    );
    this.sumaAniosMesInicio = ultimoDia.toISOString().slice(0, 10);
  }

  onSubmit() {
    let planInstitucionalActivo: number;
    let idPlanInstitucionalActivo: number;
    //let dataUnPlanInstitucionalActivo: any[];
    if (
      this.formPlanInstitucional.value.fechaInicio >
      this.formPlanInstitucional.value.fechaFin
    ) {
      this.alert.fechaError();
      return false;
    }
    this.submitted = true;
    this.formPlanInstitucional.value.usuario = this.currentUser.idSprUsuario;
    this.formPlanInstitucional.value.ip = this.ipAddress;
    this.formPlanInstitucional.value.descripcion = '';
    planInstitucionalActivo = this.formPlanInstitucional.value.estado;
    idPlanInstitucionalActivo =
      this.formPlanInstitucional.value.idSprPlanInstitucional;
    if (!this.formPlanInstitucional.invalid) {
      if (this.formPlanInstitucional.value.idSprPlanInstitucional == null) {
        if (this.listPlanExiste(this.formPlanInstitucional.value.nombre)) {
          //para que no repita el mismo nombre SOLO EN CREATE
          if (
            this.listFechashasExiste(
              this.formPlanInstitucional.value.fechaInicio,
              this.formPlanInstitucional.value.fechaFin
            )
          ) {
            //control para que se cree 4 años al momento de guardar

            if (this.formPlanInstitucional.value.fechaFin > this.sumaAniosMes) {
              this.alert.warning('¡Atención!','La fecha fin no debe sobrepasar de 4 años.');
            } else {
              //para que no repitan las fechas de inicio y fin
              this.planInstitucionalService
                .create(this.formPlanInstitucional.value)
                .subscribe({
                  next: (resp) => {
                    this.initApp();
                    this.modal.close();
                    this.alert.createOk();
                    this.submitted = false;
                  },
                  error: (err) => {
                    this.alert.createError();
                  },
                });
            }
            //fin del control  de 4 años
          }
        }
      } else {
        //inicio
        //
        if (
          this.listPlanExisteDiferente(
            this.formPlanInstitucional.value.nombre,
            this.formPlanInstitucional.value.idSprPlanInstitucional
          )
        ) {
          if (
            this.listFechashasExisteDiferente(
              this.formPlanInstitucional.value.fechaInicio,
              this.formPlanInstitucional.value.fechaFin,
              this.formPlanInstitucional.value.idSprPlanInstitucional
            )
          ) {
            if (this.formPlanInstitucional.value.estado == this.estadoActivo) {
              if (this.sumaAniosMes === undefined) {
                this.sumaAniosMes = this.sumaAniosMesInicio;
              }
              this.planInstitucionalService
                .list(`?estado=` + this.estadoActivo)
                .subscribe({
                  next: (resp) => {
                    this.dataPlanesAniosEstado = resp;

                    let valor =
                      this.dataPlanesAniosEstado.idSprPlanInstitucional;
                    /**Inicio If */
                    if (this.dataPlanesAniosEstado.length == 1) {
                      if (
                        this.formPlanInstitucional.value.estado ===
                          this.dataPlanesAniosEstado[0].estado &&
                        this.formPlanInstitucional.value
                          .idSprPlanInstitucional ===
                          this.dataPlanesAniosEstado[0].idSprPlanInstitucional
                      ) {
                        //
                        //aqui traer los planes diferentes del que se va a actualizar
                        //inicio

                        if (
                          this.formPlanInstitucional.value.fechaFin >
                          this.sumaAniosMes
                        ) {
                          this.alert.warning('¡Atención!','La fecha fin no debe sobrepasar de 4 años.'
                          );
                        } else {
                          this.planInstitucionalService
                            .update(this.formPlanInstitucional.value)
                            .subscribe({
                              next: (resp) => {
                                this.initApp();
                                this.modal.close();
                                this.alert.updateOk();
                                this.submitted = false;
                              },
                              error: (err) => {
                                this.alert.updateError();
                              },
                            });
                        } //fin

                        //
                      }
                      //
                      else {
                        this.alert.createError('¡Error! Ya  existe un plan activo.'
                        );
                      }
                    } else {
                      //
                      if (
                        this.formPlanInstitucional.value.fechaFin >
                        this.sumaAniosMes
                      ) {
                        this.alert.warning('¡Atención!',
                          'La fecha fin no debe sobrepasar de 4 años.'
                        );
                      } else {
                        //inicio
                        this.planInstitucionalService
                          .update(this.formPlanInstitucional.value)
                          .subscribe({
                            next: (resp) => {
                              this.initApp();
                              this.modal.close();
                              this.alert.updateOk();
                              this.submitted = false;
                            },
                            error: (err) => {
                              this.alert.updateError();
                            },
                          });
                      } //fin
                      //
                    }

                    /**Fin If */
                  },
                });
              //fin controlar
            } else {
              /**Se inactiva los planes anios del plan institucional que se  inactiva */

              //no se repita las fechas de inicio y fin

              //inicio
              if (this.listPlanExisteDiferente(this.formPlanInstitucional.value.nombre,this.formPlanInstitucional.value.idSprPlanInstitucional)) {
                if (this.listFechashasExisteDiferente(this.formPlanInstitucional.value.fechaInicio,this.formPlanInstitucional.value.fechaFin,this.formPlanInstitucional.value.idSprPlanInstitucional)){
                  if (this.sumaAniosMes === undefined) {
                    this.sumaAniosMes = this.sumaAniosMesInicio;
                  }

                  if (this.sumaAniosMes >= this.formPlanInstitucional.value.fechaFin ) {
                    this.alert.warning('¡Atención!', 'La fecha fin no puede ser mayor a la fecha inicio.');
                  } else {
                    this.planInstitucionalService
                      .update(this.formPlanInstitucional.value)
                      .subscribe({
                        next: (resp) => {
                          this.planesAniosService
                            .list(
                              `?idSprPlanInstitucional=` +
                                this.formPlanInstitucional.value
                                  .idSprPlanInstitucional
                            )
                            .subscribe({
                              next: (resp) => {
                                this.dataPlanesAniosInactivos = resp;
                                this.aniosInactivos =
                                  this.dataPlanesAniosInactivos.map(
                                    (x: any) => {
                                      x.estado = 2;
                                      return x;
                                    }
                                  );
                                this.vectorAnios = this.aniosInactivos;
                                for (let clave of this.vectorAnios) {
                                  this.planesAniosService
                                    .update(clave)
                                    .subscribe({
                                      next: (resp) => {},

                                      error: (err) => {
                                        this.alert.updateError();
                                      },
                                    });
                                }
                                this.alert.success('¡Correcto!',
                                  'Registro actualizado satisfactoriamente. Se actualizo con estado:Inactivo los registos de planes años.'
                                );
                              },
                            });

                          this.initApp();
                          this.modal.close();
                          //this.alert.updateOk();
                          this.submitted = false;
                        },
                        error: (err) => {
                          this.alert.updateError();
                        },
                      });

                    //fin
                  }
                }
              }
            } //fin
          } //aqui fin
        }
      }
    } else {
      this.alert.createError();
      return false;
    }
    return false;
  }

  edit(obj: PlanInstitucional) {
    this.controlFechasAniosInicio(obj.fechaInicio);
    this.openModal();

    this.formPlanInstitucional.patchValue({
      idSprPlanInstitucional: obj.idSprPlanInstitucional,
      nombre: obj.nombre,
      //descripcion: obj.descripcion,
      mision: obj.mision,
      vision: obj.vision,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      estado: obj.estado,
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete');
    this.idDeleteRegister = idRegister;
  }

  verificarPlan() {
    //validacion para no eliminar y relaciones
    this.planAniosService
      .list(`?idSprPlanInstitucional=${this.idDeleteRegister}&delLog=N`)
      .subscribe((res) => {
        this.dataPlan = res;
      });
  }

  verificarYear() {
    //validacion para no eliminar y relaciones
    return this.planAniosService
      .list(`?idSprPlanInstitucional=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verificarYear();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################
    if (confirmDelete) {
      this.planInstitucionalService
        .delete({
          idSprPlanInstitucional: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.deleteOk();
            this.modal.closeId('delete');
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    } else {
      this.alert.warning(
        '¡Atención!',
        'No se puede borrar, existen Planes-Años relacionados.'
      );
    }
    this.modal.closeId('delete');
  }

  listPlanExiste(nombre: any) {
    // para que no se repita los nombres
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    for (let elemento of this.dataApp) {
      if (elemento.nombre == nombresFin) {
        this.alert.warning(
          '¡Atención!',
          'Existe un Plan Institucional con el mismo nombre.'
        );
        return false;
      }
    }
    return true;
  }

  listPlanExisteDiferente(nombre: any, idSprPlanInstitucional: any) {
    let vector: any = [];
    let vectorFiltrado: any = [];

    // para que no se repita los nombres
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    vector = this.dataApp;
    //vectorFiltrado = vector.filter((elemento) => elemento != idSprPlanInstitucional)
    for (let elemento of vector) {
      if (elemento.idSprPlanInstitucional !== idSprPlanInstitucional) {
        vectorFiltrado.push(elemento);

        //return false;
      }
    }

    for (let elemento of vectorFiltrado) {
      if (elemento.nombre == nombresFin) {
        this.alert.warning(
          '¡Atención!',
          'Existe un Plan Institucional con el mismo nombre.'
        );
        return false;
      }
    }
    return true;
  }

  listFechashasExiste(fechaInicioFormulario: any, fechaFinFormulario: any) {
    // Funcion para que no se repita las fechas
    let fechaInicio;
    let fechaFin;
    for (let elemento of this.dataApp) {
      fechaInicio = elemento.fechaInicio;
      fechaFin = elemento.fechaFin;

      if (
        (fechaInicioFormulario >= fechaInicio &&
          fechaInicioFormulario <= fechaFin) ||
        (fechaFinFormulario >= fechaInicio && fechaFinFormulario <= fechaFin)
      ) {
        this.alert.warning('¡Atención!','La fecha inicio o fecha fin ya existen. ');
        return false;
      }
    }
    return true;
  }

  listFechashasExisteDiferente(
    fechaInicioFormulario: any,
    fechaFinFormulario: any,
    idSprPlanInstitucional: any
  ) {
    // Funcion para que no se repita las fechas
    let vector: any = [];
    let vectorFiltrado: any = [];
    let fechaInicio;
    let fechaFin;
    vector = this.dataApp;

    for (let elemento of vector) {
      if (elemento.idSprPlanInstitucional !== idSprPlanInstitucional) {
        vectorFiltrado.push(elemento);
        //return false;
      }
    }

    for (let elemento of vectorFiltrado) {
      fechaInicio = elemento.fechaInicio;
      fechaFin = elemento.fechaFin;

      if (
        (fechaInicioFormulario >= fechaInicio &&
          fechaInicioFormulario <= fechaFin) ||
        (fechaFinFormulario >= fechaInicio && fechaFinFormulario <= fechaFin)
      ) {
        this.alert.warning('¡Atención!',
          'La fecha inicio o fecha fin ya pertenece a algun plan. '
        );
        return false;
      }
    }
    return true;
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }

  onResetForm() {
    this.submitted = false;
    this.formPlanInstitucional.reset();
  }
}
